import { DateViewCell } from "../types";
import { modifyDate } from "../utils";

const groupByWeeks = (cells: DateViewCell[]): Array<Array<DateViewCell>> => {
  return cells.reduce(
    (acc: Array<Array<DateViewCell>>, cell: DateViewCell, index: number) => {
      const weekIndex = Math.floor(index / 7);

      // Если еще нет массива для текущей "недели", создаем его
      if (!acc[weekIndex]) {
        acc[weekIndex] = [];
      }

      // Добавляем текущий элемент в соответствующую "неделю"
      acc[weekIndex].push(cell);

      return acc;
    },
    []
  );
};

/**
 * * Сгенерировать ячейки DateViewCell
 * @param year Год
 * @param monthIndex Индекс месяца
 * @returns
 */
export function generateDateViewCells(
  year: number,
  monthIndex: number
): Array<Array<DateViewCell>> {
  const firstDayOfMonth = new Date(year, monthIndex, 1);
  const lastDayOfMonth = new Date(year, monthIndex + 1, 0);
  const daysInMonth = lastDayOfMonth.getDate();

  // Определяем день недели для первого дня месяца (0 - воскресенье, 1 - понедельник, и т.д.)
  const startDay = firstDayOfMonth.getDay();

  // Корректируем startDay, чтобы понедельник был первым днем (0)
  const adjustedStartDay = (startDay + 6) % 7;

  const cells: (DateViewCell | null)[] = new Array(42).fill(null);

  // Заполняем ячейки днями текущего месяца
  for (let day = 1; day <= daysInMonth; day++) {
    const cellIndex = adjustedStartDay + day - 1; // Вычисляем индекс ячейки
    const date = new Date(year, monthIndex, day);
    const mDate = modifyDate(date);
    cells[cellIndex] = {
      date,
      text: date.getDate().toString(),
      timestamp: date.getTime(),
      offsetMonth: "current",
      isWeekend: mDate.isWeekend(),
      isCurrent: mDate.isCurrent(),
      weekNum: mDate.getWeekNumber(),
    };
  }

  // Заполняем недостающие ячейки днями из предыдущего месяца
  const previousMonthIndex = monthIndex - 1;
  const lastDayOfPreviousMonth = new Date(year, previousMonthIndex + 1, 0);
  const daysInPreviousMonth = lastDayOfPreviousMonth.getDate();

  // Заполняем ячейки предыдущего месяца, если не хватает
  for (let i = adjustedStartDay - 1; i >= 0; i--) {
    const date = new Date(
      year,
      previousMonthIndex,
      daysInPreviousMonth - (adjustedStartDay - 1 - i)
    );
    const mDate = modifyDate(date);

    cells[i] = {
      date,
      text: date.getDate().toString(),
      timestamp: date.getTime(),
      offsetMonth: "prev",
      isWeekend: mDate.isWeekend(),
      isCurrent: mDate.isCurrent(),
      weekNum: mDate.getWeekNumber(),
    };
  }

  // Заполняем недостающие ячейки днями из следующего месяца
  const nextMonthIndex = monthIndex + 1;
  for (let i = adjustedStartDay + daysInMonth; i < 42; i++) {
    const dayFromNextMonth = i - adjustedStartDay - daysInMonth + 1; // Вычисляем номер дня из следующего месяца
    const date = new Date(year, nextMonthIndex, dayFromNextMonth);
    const mDate = modifyDate(date);
    cells[i] = {
      date,
      text: date.getDate().toString(),
      timestamp: date.getTime(),
      offsetMonth: "next",
      isWeekend: mDate.isWeekend(),
      isCurrent: mDate.isCurrent(),
      weekNum: mDate.getWeekNumber(),
    };
  }

  return groupByWeeks(cells as DateViewCell[]); // Возвращаем массив ячеек
}
